// extracted by mini-css-extract-plugin
module.exports =  {"panelHeader":"panelHeader__QedfR","iconHolder":"iconHolder__qfUzs","title":"title__NEqFk","formArea":"formArea__63cEw"};